<template>
  <Section
    :id="id"
    :header="t('orders.relatedOrders', 2)"
    class="related-orders-section"
    data-class="related-orders-section-data flex flex-column flex-gap-1"
  >
    <RelatedOrderLoadingCard
      v-if="orders.loading || orders.data === undefined"
    />
    <RelatedOrderCard
      v-for="(order, index) in orders.data"
      :key="index"
      :order="order"
      class="related-order"
    />
  </Section>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Loadable } from '@rygen/rygen-ui/model';

import { Order } from '@/model';

import RelatedOrderCard from '@/components/relatedOrders/RelatedOrderCard.vue';
import RelatedOrderLoadingCard from '@/components/relatedOrders/RelatedOrderLoadingCard.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  orders: {
    type: Object as PropType<Loadable<Order[]>>,
    required: true,
  },
});
const { id, orders } = toRefs(props);
const { t } = useI18n();
</script>
